import {types} from 'mobx-state-tree';
import {ListingProvider} from '../enums';

export type GuestViews = {
  name: string;
};

const GuestModel = types
  .model('Guest', {
    id: types.identifierNumber,
    firstName: types.string,
    lastName: types.maybe(types.string),
    email: types.maybe(types.string),
    phone: types.maybe(types.string),
    source: types.maybe(ListingProvider)
  })
  .views<GuestViews>(self => ({
    get name() {
      const {firstName, lastName} = self;
      return lastName ? `${firstName} ${lastName}` : firstName;
    }
  }));

export type GuestModelType = typeof GuestModel.Type;

export default GuestModel;



// WEBPACK FOOTER //
// ./src/models/GuestModel/GuestModel.ts